import { API } from '@ax/api';
import { API_SERVICES } from './utils';
import {
  GetAllTranscriptApiResponse,
  TranscriptParams,
  TranscriptRecording,
} from './transcript-interface';

export const getTranscript = async ({
  noteId,
  transcriptId,
}: TranscriptParams): Promise<GetAllTranscriptApiResponse[]> => {
  const data = await API.get(API_SERVICES.TRANSCRIPT_API, `/${noteId}/${transcriptId}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return data.data;
};

export const getAllTranscriptFromNotesList = async (
  data: string[],
): Promise<TranscriptRecording[]> => {
  const res = await API.post(API_SERVICES.TRANSCRIPT_API, `/getnotes`, {
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.data;
};

export const reprocessNote = async (noteId: any): Promise<any> => {
  const res = await API.post(API_SERVICES.TRANSCRIPT_API, `note/reprocess/${noteId}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.data;
};
